
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/reset.css";
import i18n from "@/i18n/i18n.js";
import ElementUI from "element-ui";
import { goPAGE } from "./utils/utils";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/font/iconfont.css";
import "@/assets/font/iconfont.js";
import plugin from "./utils/Bus";
import axios from "axios";
import "wowjs/css/libs/animate.css";
import VueScrollReveal from "vue-scroll-reveal";
import { Notify, Icon, Popup , Pagination } from "vant";
import * as echarts from 'echarts'
import world from 'echarts/map/json/world.json'
echarts.registerMap('world', world)
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
Vue.prototype.$echarts = echarts;
Vue.prototype.$http = axios;
Vue.use(plugin);
const classify = goPAGE();
Vue.use(ElementUI);
Vue.use(VueScrollReveal, {
  duration: 2000,
  scale: 1,
  distance: "200px",
  reset: true,
  mobile: false,
  useDelay: "always",
  origin: "bottom",
  easing: "linear",
});

Vue.config.productionTip = false;

if (goPAGE() == "pc") {
  router.push({ path: "/pc/Index" });
} else {
  router.push({ path: "/m/Index" });
}

Vue.use(Popup);
Vue.use(Icon);
Vue.use(Pagination);

Vue.use(Notify);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

router.beforeEach((to, from, next) => {
  // if (this.userEmail !== "" || this.userEmail !== null) {
  //   this.userEmail = localStorage.getItem("email");
  // }
  if (to.fullPath.indexOf(classify) == -1) {
    next(`/${classify}`);
  }
  // chrome
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;
  next();
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
